import * as React from "react";
const SvgDownload4 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13 10h5l-6 6-6-6h5V3h2zm-9 9h16v-3h2v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4h2z" }));
export default SvgDownload4;
